import React from 'react'
import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { Box } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import moment from 'moment'

import './GlobalAttentionComponent.scss'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import TopicHelpers from '../../classes/TopicHelpers'
import Thumbnail from '../widgets/Thumbnail'
import { ATTENTION_INDEX_TOTAL_ENGAGEMENT, ATTENTION_INDEX_VIDEO_ENGAGEMENT, ATTENTION_INDEX_NON_VIDEO_ENGAGEMENT } from '../../constants/commons'


export class GlobalAttentionMetricsTable extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    attentionIndexDetails: PropTypes.object,
    selectedDistributions: PropTypes.array,
    selectedPlatforms: PropTypes.array,
    selectedGenres: PropTypes.array,
    selectedView: PropTypes.string,
    dateIndex: PropTypes.number
  }

  constructor (props) {
    super(props)

    this.state = {
      searchText: '',
      order: 'desc',
      orderBy: ATTENTION_INDEX_TOTAL_ENGAGEMENT
    }
    this.searchRef = React.createRef()
  }

  componentDidUpdate (prevProps) {
    if (this.state.searchText.length > 0) {
      this.searchRef.current.focus()
    }
    if (prevProps.selectedView !== this.props.selectedView || prevProps.dateIndex !== this.props.dateIndex) {
      this.setState( {
        order: 'desc',
        orderBy: ATTENTION_INDEX_TOTAL_ENGAGEMENT
      })
    }
  }

  onSearchTextChange = (e) => {
    this.setState({searchText: e.target.value})
    this.searchRef.current.focus()
  }

  descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1
    }
    if (b[orderBy] > a[orderBy]) {
      return 1
    }
    return 0
  }

  getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy)
  }

  sortData = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0])
      if (order !== 0) return order
      return a[1] - b[1]
    })
    return stabilizedThis.map((el) => el[0])
  }

  createSortHandler = (property) => {
    const isDesc = this.state.orderBy === property && this.state.order === 'desc'
    this.setState({
      order: isDesc ? 'asc' : 'desc',
      orderBy: property
    })
  }

  getNetworklabel = (network) => {
    return network && network.length > 0 ? network : []
  }

  formatDate = (date) => {
    if (date) {
      return moment(date).format('MMM DD, YYYY')
    }
    return date
  }

  render () {
    const { selectedDistributions, selectedPlatforms, selectedGenres } = this.props
    const StyledTableCell = withStyles(() => ({
      head: {
        background: '#F4F5F6'
      }
    }))(TableCell)
    const style = {
      width: 30,
      height: 30,
      borderRadius: 3
    }
    let rowData = this.props.attentionIndexDetails && this.props.attentionIndexDetails.details
    let rows = this.state.searchText.length > 0 ? rowData.filter(e => e.name.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1) : rowData
    if (selectedDistributions && selectedDistributions.length > 0) {
      rows = rows && selectedDistributions.length > 0 ? selectedDistributions.flatMap(network => rows.filter(t => this.getNetworklabel(t.distributions).indexOf(network) > -1)) : rows
    }
    if (selectedPlatforms && selectedPlatforms.length > 0) {
      rows = rows && selectedPlatforms.length > 0 ? selectedPlatforms.flatMap(network => rows.filter(t => this.getNetworklabel(t.labels).indexOf(network) > -1)) : rows
    }
    if (selectedGenres && selectedGenres.length > 0) {
      rows = rows && selectedGenres.length > 0 ? selectedGenres.flatMap(network => rows.filter(t => this.getNetworklabel(t.genre).indexOf(network) > -1)) : rows
    }
    rows = this.sortData(rows, this.getComparator(this.state.order, this.state.orderBy))

    return (
      <>
        { (this.props.attentionIndexDetails && this.props.attentionIndexDetails.isFetching) &&
        <div className='loadingProgress'>
          <CircularProgress />
        </div>
        }
        { (this.props.attentionIndexDetails && this.props.attentionIndexDetails.details) &&
        <TableContainer className="metricsTable contentAttentionIndexTable">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell>
                  <input type="text" name="name" placeholder="Name" className="nameInput" autoComplete="off" ref={this.searchRef} value={this.state.searchText} onChange={this.onSearchTextChange}/>
                </StyledTableCell>
                <StyledTableCell>
                  <Box className='metricsTable'>Type</Box>
                </StyledTableCell>
                <StyledTableCell>
                  Premiere
                </StyledTableCell>
                <StyledTableCell>
                  Platform
                </StyledTableCell>
                <StyledTableCell>
                  <Box>Genre</Box>
                </StyledTableCell>
                <StyledTableCell sortDirection={this.state.orderBy === ATTENTION_INDEX_VIDEO_ENGAGEMENT ? this.state.order : false}>
                  <TableSortLabel
                    active={this.state.orderBy === ATTENTION_INDEX_VIDEO_ENGAGEMENT}
                    direction={this.state.orderBy === ATTENTION_INDEX_VIDEO_ENGAGEMENT ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler(ATTENTION_INDEX_VIDEO_ENGAGEMENT)}
                    >
                    <Box className='metricsTable'>Video Engagements</Box>
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell sortDirection={this.state.orderBy === ATTENTION_INDEX_NON_VIDEO_ENGAGEMENT ? this.state.order : false}>
                  <TableSortLabel
                    active={this.state.orderBy === ATTENTION_INDEX_NON_VIDEO_ENGAGEMENT}
                    direction={this.state.orderBy === ATTENTION_INDEX_NON_VIDEO_ENGAGEMENT ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler(ATTENTION_INDEX_NON_VIDEO_ENGAGEMENT)}
                    >
                    <Box className='metricsTable'>Non-video Engagements</Box>
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell sortDirection={this.state.orderBy === ATTENTION_INDEX_TOTAL_ENGAGEMENT ? this.state.order : false}>
                  <TableSortLabel
                    active={this.state.orderBy === ATTENTION_INDEX_TOTAL_ENGAGEMENT}
                    direction={this.state.orderBy === ATTENTION_INDEX_TOTAL_ENGAGEMENT ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler(ATTENTION_INDEX_TOTAL_ENGAGEMENT)}
                    >
                    <Box className='metricsTable'>Total Engagements</Box>
                  </TableSortLabel>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            { (this.props.attentionIndexDetails && this.props.attentionIndexDetails.details.length === 0) &&
              <div className='noData'> No data found</div>
            }
            <TableBody>
              { rows && rows.length > 0 &&
                rows.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell><Box>{index+1}</Box></TableCell>
                    <TableCell align="left">
                      <Thumbnail
                        entityOverrideImage={(row.entity_override_image && row.entity_override_image.indexOf('http') === -1) ? row.entity_override_image : null}
                        thumbnail={(row.thumbnail && row.thumbnail.indexOf('http') > -1) ? row.thumbnail : null}
                        name={row.name || row.display_name}
                        imageDivStyle={style}
                        noImgTextClass={'aaNoImgText'}
                        noImgClass={'aaNoImg'}
                        divId={`content_preference_${index}`}
                      />
                    </TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.entity_type}</TableCell>
                    <TableCell>{this.formatDate(row.active_date)}</TableCell>
                    <TableCell>{TopicHelpers.getNetworkLabel(row.labels)}</TableCell>
                    <TableCell>{row.genre && row.genre.length > 2 ? 'Multiple' : row.genre && row.genre.length === 2 ? row.genre.join().replace(',', ', ') : row.genre}</TableCell>
                    <TableCell>{row.video_score ? parseFloat(row.video_score).toLocaleString('en') : 0}</TableCell>
                    <TableCell>{row.non_video_score ? parseFloat(row.non_video_score).toLocaleString('en') : 0}</TableCell>
                    <TableCell>{row.score ? parseFloat(row.score).toLocaleString('en') : 0}</TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
      }
      </>
    )
  }
}

export default withStyles(styles)(GlobalAttentionMetricsTable)
